import { useSelector } from "react-redux";
import { State } from "../../app/store";

export default function useThemeColor() {
const saleConfiguration = useSelector((state: State) => state.config.configuration);

   document.documentElement.style.setProperty("--main-color", saleConfiguration.actionColor);
   document.documentElement.style.setProperty("--opacity-main-color", saleConfiguration.ticketBackgroundColor);
   document.documentElement.style.setProperty("--second-color", saleConfiguration.ticketTextColor);
   document.documentElement.style.setProperty("--opacity-second-color", saleConfiguration.mainTextColor);
   document.documentElement.style.setProperty("--background-color", saleConfiguration.backgroundColor);
  document.documentElement.style.setProperty("--aditional-color", saleConfiguration.additionalColor);

}


